import axios from 'axios';

const API_BASE = '/api/employee-messages';

export const employeeMessageService = {
  listMine: async (params = {}) => {
    const response = await axios.get(`${API_BASE}/mine`, { params });
    return response.data;
  },

  getMineUnreadCount: async () => {
    const response = await axios.get(`${API_BASE}/mine/unread-count`);
    return response.data;
  },

  createMine: async (body) => {
    const response = await axios.post(`${API_BASE}/mine`, body);
    return response.data;
  },

  replyMine: async (id, body) => {
    const response = await axios.post(`${API_BASE}/mine/${id}/replies`, body);
    return response.data;
  },

  deleteMine: async (id) => {
    const response = await axios.delete(`${API_BASE}/mine/${id}`);
    return response.data;
  },

  getUnreadCount: async () => {
    const response = await axios.get(`${API_BASE}/unread-count`);
    return response.data;
  },

  list: async (params = {}) => {
    const response = await axios.get(API_BASE, { params });
    return response.data;
  },

  create: async (body) => {
    const response = await axios.post(API_BASE, body);
    return response.data;
  },

  reply: async (id, body) => {
    const response = await axios.post(`${API_BASE}/${id}/replies`, body);
    return response.data;
  },

  update: async (id, body) => {
    const response = await axios.patch(`${API_BASE}/${id}`, body);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`);
    return response.data;
  }
};
